import { I18n } from '@calendly/i18n'
import { QuestionCircleIcon } from '@calendly/ui/components/icons'
import { PageHeader } from '@calendly/ui/components/page-header'
import { TitleText } from '@calendly/ui/components/typography'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { Container } from 'components/organizations/layout'
import { LearnMoreButton, OccupancyRatio } from 'components/page_elements'
import { useContextualHelp } from 'features/contextual_help'
import { CONTENT_PAGES, useNewEmptyStates } from 'features/empty_state'
import { fetchStatistics, statisticsSelector } from 'features/organization_statistics'
import { UpgradeBanner } from 'features/upgrade_banner'
import { AddNewUser } from 'features/users_page/add_new_user'
import { Switcher } from 'features/users_page/switcher'
import { isAdminOrOwnerSelector, isGroupAdminSelector } from 'selectors/current_user'

import { List } from './list'

export const Page = () => {
  const dispatch = useDispatch()
  const isNewEmptyStatesEnabled = useNewEmptyStates()
  const isUserGroupAdminSelector = useSelector(isGroupAdminSelector)
  const isOwnerOrAdmin = useSelector(isAdminOrOwnerSelector)
  const { occupancyRatio } = useSelector(statisticsSelector)
  const { pathname } = useLocation()
  const isGroupAdminOrOwner = isUserGroupAdminSelector || isOwnerOrAdmin
  const { open: openContextualHelp } = useContextualHelp()

  const onClickLearnMore = () => {
    openContextualHelp({ contentKey: CONTENT_PAGES.users })
  }

  useEffect(() => {
    dispatch(fetchStatistics())
  }, [dispatch, pathname])


  return (
    <>
      <PageHeader
        eyebrow={(
        isGroupAdminOrOwner && (
        <TitleText variant="eyebrow">
          {I18n.t('publisher.admin.navigation.people')}
        </TitleText>
        )
      )}
        title={!isGroupAdminOrOwner
          ? I18n.t('publisher.personal_settings.navigation.org_directory')
          : I18n.t('publisher.admin.navigation.users')}
        tabs={<Switcher />}
        actions={[
          <AddNewUser key="add-new-user" />
        ]}
        description={<OccupancyRatio ratio={occupancyRatio} isAdminIa />}
        protip={isNewEmptyStatesEnabled && (
        <LearnMoreButton
          onClick={onClickLearnMore}
          aria-label={I18n.t('publisher.contextual_help.page_title.adding_users_overview')}
        >
          <QuestionCircleIcon />
        </LearnMoreButton>
        )}
      />
      <Container>
        {isNewEmptyStatesEnabled && <UpgradeBanner featureKey="organization_invitation" contentKey={CONTENT_PAGES.users} />}
        <List />
      </Container>
    </>
  )
}
